<template>
  <div class="filter" :class="{ '--is-active': activeButton > 0 }">
    <!-- <span class="filter-title">Filter:</span>
    <input type="text" v-model="boxQty"> -->

    <div class="filter-option" :class="{ '--is-active': activeButton === 6 }">
      <Button
        appearance="secondary"
        class="--flex-button"
        :class="{ '--is-active': activeButton === 6 }"
        @click="showFilter(6)"
      >
        Enthaltene Delikatessen
        <i class="icon icon-angle-up" v-if="activeButton === 6"></i>
        <i class="icon icon-angle-down" v-else></i>
      </Button>

      <div class="filter-panel panel --has-no-padding form__check" v-if="activeButton === 6">
        <ul>
          <li>
            <input
              type="text"
              placeholder="Enthaltene Delikatessen suchen"
              class="form__control"
              v-model="categorySearch"
              @keyup="createFiltersLevel1()"
              @search="createFiltersLevel1()"
            />
          </li>
          <li v-for="(category, index) in filterCache.categories" :key="category">
            <input
              class="form-check__input category-input"
              type="checkbox"
              :id="'filter[categories][' + index + ']'"
              :checked="
                $store.getters.getLevel1Filter.categories.includes(category)
              "
              @change="level1CategoryChange($event.target.checked, category)"
            />
            <label :for="'filter[categories][' + index + ']'">
              {{
              category
              }}
            </label>
          </li>
          <li class="--button-line">
            <Button appearance="primary" @click="showFilter(6)">Filter anwenden</Button>
            <a @click="level1CategoryClear()">Filter löschen</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="filter-option" :class="{ '--is-active': activeButton === 2 }">
      <Button
        appearance="secondary"
        class="--flex-button"
        :class="{ '--is-active': activeButton === 2 }"
        @click="showFilter(2)"
      >
        Preis
        <i class="icon icon-angle-up" v-if="activeButton === 2"></i>
        <i class="icon icon-angle-down" v-else></i>
      </Button>

      <div class="filter-panel panel --has-no-padding form__check" v-if="activeButton === 2">
        <ul>
          <li>
            <vue-slider
              v-if="loadedCash"
              v-model="priceRange"
              :min="filterCache.min"
              :max="filterCache.max"
              :min-range="1"
              :enable-cross="false"
              :tooltip="'none'"
              @change="level1PriceChange"
            ></vue-slider>
          </li>
          <li class="--price-filter">
            <div>
              <span>Min. Preis €</span>
              <input type="text" class="form__control" v-model="minInput" ref="minPrice" @click="selectMin" />
            </div>
            <div>
              <span>Max. Preis €</span>
              <input type="text" class="form__control" v-model="maxInput" ref="maxPrice" @click="selectMax" />
            </div>
          </li>
          <li v-if="$store.getters.isB2b">
            <input
              class="form-check__input attribute-input"
              type="checkbox"
              :id="'filter[b2b][useB2c]'"
              :checked="$store.getters.getLevel1Filter.useB2cPrices"
              @change="level1UseB2cPrices($event.target.checked)"
            />
            <label :for="'filter[b2b][useB2c]'">brutto (inkl. Mwst.)</label>
          </li>
          <li class="--button-line">
            <Button appearance="primary" @click="showFilter(2)">Filter anwenden</Button>
            <a @click="level1PriceClear()">Filter löschen</a>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="filter-option"
      :class="{ '--is-active': activeButton === 4 }"
      v-if="$store.getters.isB2b"
    >
      <Button
        appearance="secondary"
        class="--flex-button"
        :class="{ '--is-active': activeButton === 4 }"
        @click="showFilter(4)"
      >
        Lieferzeit
        <i class="icon icon-angle-up" v-if="activeButton === 4"></i>
        <i class="icon icon-angle-down" v-else></i>
      </Button>
      <div class="filter-panel panel --has-no-padding form__check" v-if="activeButton === 4">
        <ul>
          <li>
            <vue-slider
              v-if="loadedCash"
              v-model="b2bTime"
              :data="getDeliveryTimeSteps"
              :tooltip="'none'"
            ></vue-slider>
          </li>
          <li v-if="b2bTime === 0">schnellstmöglich</li>
          <li v-else-if="b2bTime === 1">Sofort</li>
          <li v-else-if="b2bTime > 1 && b2bTime <= 14">in {{ b2bTime }} Tagen versandfertig</li>
          <li v-else-if="b2bTime > 14">am {{ getDeliveryReadyDateString(b2bTime) }} versandfertig</li>
          <li v-else>Alle Lieferzeiten anzeigen</li>
          <li class="--button-line">
            <Button appearance="primary" @click="showFilter(4)">Filter anwenden</Button>
            <a @click="level1ResetB2bTime()">Filter löschen</a>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="filter-option"
      :class="{ '--is-active': activeButton === 5 }"
      v-if="$store.getters.isB2b"
    >
      <Button
        appearance="secondary"
        class="--flex-button"
        :class="{ '--is-active': activeButton === 5 }"
        @click="showFilter(5)"
      >
        Anzahl
        <i class="icon icon-angle-up" v-if="activeButton === 5"></i>
        <i class="icon icon-angle-down" v-else></i>
      </Button>
      <div class="filter-panel panel --has-no-padding form__check" v-if="activeButton === 5">
        <ul>
          <li>
            <vue-slider v-if="loadedCash" v-model="b2bQty" :min="0" :max="1000" :tooltip="'none'"></vue-slider>
          </li>
          <li class="--price-filter">
            <div>
              <span>Ihre benötigte Anzahl</span>
              <input type="text" class="form__control" v-model="b2bQty" />
            </div>
          </li>
          <li class="--button-line">
            <Button appearance="primary" @click="showFilter(5)">Filter anwenden</Button>
            <a @click="level1ResetB2bQty()">Filter löschen</a>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="$store.getters.isB2b" class="filter-option" :class="{ '--is-active': activeButton === 6 }">
      <Button
        appearance="secondary"
        class="--flex-button"
        :class="{ '--is-active': activeButton === 7 }"
        @click="showFilter(7)"
      >
        Eigenschaften
        <i class="icon icon-angle-up" v-if="activeButton === 7"></i>
        <i class="icon icon-angle-down" v-else></i>
      </Button>

      <div class="filter-panel panel --has-no-padding form__check" v-if="activeButton === 7">
        <ul>
          <li v-for="item in filterCache.tags" :key="item.level1_feature_title">
            <input
              class="form-check__input tag-input"
              type="checkbox"
              :id="'filter[tags][' + item.level1_feature_title + ']'"
              :checked="
                $store.getters.getLevel1Filter.tags.includes(item.level1_feature_title)
              "
              @change="level1TagChange($event.target.checked, item.level1_feature_title)"
            />
            <label :for="'filter[tags][' + item.level1_feature_title + ']'">
              {{
              item.level1_feature_title
              }}
            </label>
          </li>
          <li class="--button-line">
            <Button appearance="primary" @click="showFilter(7)">Filter anwenden</Button>
            <a @click="level1TagClear()">Filter löschen</a>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="filter-tags"
      v-if="
        (loadedCash &&
          ($store.getters.getLevel1Filter.b2b.qty > 0 ||
            $store.getters.getLevel1Filter.categories.length > 0 ||
            $store.getters.getLevel1Filter.tags.length > 0 ||
            $store.getters.getLevel1Filter.b2b.time > 0 ||
            priceRange[0] !== filterCache.min ||
            priceRange[1] !== filterCache.max))
      "
    >
      <span v-for="(category, index) in $store.getters.getLevel1Filter.categories" :key="index">
        {{ category }}
        <span>
          <i class="icon icon-times" @click="level1CategoryChange(false, category)"></i>
        </span>
      </span>

      <span
        v-if="
          priceRange[0] !== filterCache.min || priceRange[1] !== filterCache.max
        "
      >
        {{ priceRange[0] }} € - {{ priceRange[1] }} €
        <span>
          <i class="icon icon-times" @click="level1PriceClear()"></i>
        </span>
      </span>

      <span v-for="element in $store.getters.getLevel1Filter.tags" :key="element">
        {{ element }}
        <span>
          <i class="icon icon-times" @click="level1TagChange(false, element)"></i>
        </span>
      </span>

      <span v-if="$store.getters.getLevel1Filter.b2b.qty > 0">
        Anzahl: {{ $store.getters.getLevel1Filter.b2b.qty }}
        <span>
          <i class="icon icon-times" @click="level1ResetB2bQty()"></i>
        </span>
      </span>

      <span v-if="b2bTime === 0">
        schnellstmöglich
        <span>
          <i class="icon icon-times" @click="level1ResetB2bTime()"></i>
        </span>
      </span>
      <span v-else-if="b2bTime === 1">
        Morgen versandfertig
        <span>
          <i class="icon icon-times" @click="level1ResetB2bTime()"></i>
        </span>
      </span>
      <span v-else-if="b2bTime > 1 && b2bTime <= 14">
        in {{ b2bTime }} Tagen versandfertig
        <span>
          <i class="icon icon-times" @click="level1ResetB2bTime()"></i>
        </span>
      </span>
      <span v-else-if="b2bTime > 14">
        am {{ getDeliveryReadyDateString(b2bTime) }} versandfertig
        <span>
          <i class="icon icon-times" @click="level1ResetB2bTime()"></i>
        </span>
      </span>
      <span v-else>
        Alle Lieferzeiten anzeigen
        <span>
          <i class="icon icon-times" @click="level1ResetB2bTime()"></i>
        </span>
      </span>

      <a @click="clearAllFilters()">Alle Filter löschen</a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import Button from '@/components/Common/Button';
import { logicMixin } from '@/mixins/LogicMixin';

export default {
  name: 'FilterCatalogLevel1',
  components: { Button },
  mixins: [logicMixin],
  data: function () {
    return {
      activeButton: 0,
      filterCache: {},
      loadedCash: false,
      priceRange: [0, 100],
      categorySearch: '',
    };
  },
  created: function () {
    this.$root.$on('level1Loaded', () => {
      this.createFiltersLevel1();
    });
    this.$root.$on('settingsLoaded', () => {
      this.createFiltersLevel1();
    });
    this.createFiltersLevel1();
  },
  methods: {
    selectMin() {
      this.$refs.minPrice.select();
    },
    selectMax() {
      this.$refs.maxPrice.select();
    },
    showFilter: function (index) {
      if (this.activeButton === 0 || this.activeButton !== index) {
        this.activeButton = index;
      } else {
        this.activeButton = 0;
      }
    },
    createFiltersLevel1: function () {
      this.filterCache = {
        categories: [],
        min: 0,
        max: 0,
      };
      this.$store.getters.getListItemsLevel1.forEach((product) => {
        var price = 0;
        if (this.$store.getters.getLevel1Filter.useB2cPrices) {
          price = this.getPriceRawForGroup(product, this.$store.getters.getUserGroupId, false);
        } else {
          price = this.getPriceRaw(product);
        }

        if (this.filterCache.min === 0 || this.filterCache.min > price) {
          this.filterCache.min = Math.floor(price);
        }
        if (this.filterCache.max < price) {
          this.filterCache.max = Math.ceil(price);
        }
        product.products.forEach((realProduct) => {
          if (realProduct.category !== undefined) {
            realProduct.category.forEach(cat => {
              if (
                cat !== '' &&
                cat
                  .toLowerCase()
                  .includes(this.categorySearch.toLowerCase()) &&
                !this.filterCache.categories.includes(cat)
              ) {
                this.filterCache.categories.push(cat);
              }
            });
          }
        });
      });

      const newMin = this.$store.getters.getLevel1Filter.priceMin;
      if (newMin > this.filterCache.min) {
        Vue.set(this.priceRange, 0, newMin);
      } else {
        Vue.set(this.priceRange, 0, this.filterCache.min);
      }
      const newMax = this.$store.getters.getLevel1Filter.priceMax;
      if (newMax < this.filterCache.max) {
        Vue.set(this.priceRange, 1, newMax);
      } else {
        Vue.set(this.priceRange, 1, this.filterCache.max);
      }

      this.filterCache.categories.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
      this.filterCache.tags = {};
      this.$store.getters.getLevel1Tags.forEach((tag) => {
        this.filterCache.tags[tag.level1_feature_title] = tag;
      });
      this.loadedCash = true;
    },
    level1PriceChange: function () {
      this.$store.commit('setLevel1FilterMinPrice', this.priceRange[0]);
      this.$store.commit('setLevel1FilterMaxPrice', this.priceRange[1]);
    },
    level1PriceClear: function () {
      Vue.set(this.priceRange, 0, this.filterCache.min);
      Vue.set(this.priceRange, 1, this.filterCache.max);
      this.$store.commit('setLevel1FilterMinPrice', this.filterCache.min);
      this.$store.commit('setLevel1FilterMaxPrice', this.filterCache.max);
      this.$store.commit('setLevel1FilterUseB2cPrices', false);
      this.activeButton = 0;
    },
    level1ResetB2bQty: function () {
      this.$store.commit('setLevel1FilterB2bQty', 0);
      this.$store.commit('setLevel3FilterB2bQty', 0);
    },
    level1ResetB2bTime: function () {
      this.$store.commit('setLevel1FilterB2bTime', -1);
      this.$store.commit('setLevel3FilterB2bTime', -1);
    },
    level1UseB2cPrices: function (checked) {
      this.$store.commit('setLevel1FilterUseB2cPrices', checked);
      this.createFiltersLevel1();
    },
    clearAllFilters: function () {
      this.categorySearch = '';
      this.level1CategoryClear();
      this.level1PriceClear();
      this.level1ResetB2bQty();
      this.level1ResetB2bTime();
    },
    level1CategoryChange: function (checked, category) {
      if (checked) {
        this.$store.commit('addLevel1FilterCategory', category);
      } else {
        this.$store.commit('removeLevel1FilterCategory', category);
      }
    },
    level1CategoryClear: function () {
      this.$store.commit('clearLevel1FilterCategory');
      document.getElementsByClassName('category-input').forEach((el) => {
        if (el.checked) {
          el.checked = false;
        }
      });
      this.showFilter(6);
    },
    level1TagChange: function (checked, tag) {
      if (checked) {
        this.$store.commit('addLevel1FilterTag', tag);
      } else {
        this.$store.commit('removeLevel1FilterTag', tag);
      }
    },
    level1TagClear: function () {
      this.$store.commit('clearLevel1FilterTag');
      var els = document.getElementsByClassName('tag-input');
      Array.from(els).forEach((el) => {
        if (el.checked) {
          el.checked = false;
        }
      });
      this.showFilter(7);
    },

    clickOutside (e) {
      e.stopPropagation();

      if (!this.$el.contains(e.target) || e.target === this.$el) {
        this.activeButton = 0;
      }
    }
  },
  computed: {
    getDeliveryTimeSteps() {
      var times = [];
      var max = 0;
      this.$store.getters.getListItemsLevel1.forEach(box => {
        var qtyEnough = true;
        box.products.forEach(item => {
          if (item.replaced) {
            item = item.replaceData;
          }
          if (item.stock_quantity < this.boxQty) {
            qtyEnough = false;
          }
        });
        if (!qtyEnough) {
          times.push(this.getCalculatedTime(box));
        } else {
          const t = this.getCalculatedTime(box);
          if (t > max) {
            max = t;
          }
        }
      });
      times = times.filter(i => i > max);
      times.sort((a, b) => a - b);
      times.unshift(0);
      times = [...new Set(times)];
      times.push(-1);
      return times;
    },
    minInput: {
      get() {
        return this.priceRange[0];
      },
      set(value) {
        value = parseInt(value);
        if (!isNaN(value) && value < this.priceRange[1]) {
          Vue.set(this.priceRange, 0, value);
          this.$store.commit('setLevel1FilterMinPrice', value);
        }
      },
    },
    maxInput: {
      get() {
        return this.priceRange[1];
      },
      set(value) {
        value = parseInt(value);
        if (!isNaN(value) && value > this.priceRange[0]) {
          Vue.set(this.priceRange, 1, value);
          this.$store.commit('setLevel1FilterMaxPrice', value);
        }
      },
    },
    b2bQty: {
      get() {
        return this.$store.getters.getLevel1Filter.b2b.qty;
      },
      set(value) {
        this.$store.commit('setLevel1FilterB2bQty', value);
        this.$store.commit('setLevel3FilterB2bQty', value);
        if (parseInt(value) > 0) {
          this.$store.commit('setSelectedQty', { qty: value, store: this.$store });
        } else if (parseInt(value) === 0) {
          this.$store.commit('setSelectedQty', { qty: 1, store: this.$store });
        }
      },
    },
    b2bTime: {
      get() {
        return this.$store.getters.getLevel1Filter.b2b.time;
      },
      set(value) {
        this.$store.commit('setLevel1FilterB2bTime', value);
        this.$store.commit('setLevel3FilterB2bTime', value);
      },
    },
  },
  mounted () {
    document.addEventListener('mousedown', this.clickOutside);
  },
  destroyed () {
    document.removeEventListener('mousedown', this.clickOutside);
  }
};
</script>

<style lang="scss">
@import '../assets/styles/components/filter-catalog';
</style>
